import styled from "styled-components"

import { colors, spacing } from "@minuthq/meatball-ui-react"

export function ParadiseProductImageThumbnail({
  imageUrl,
  width = "50px",
}: {
  imageUrl: string
  width?: string
}) {
  return (
    <Box $width={width}>
      <img src={imageUrl} alt="" />
    </Box>
  )
}

const Box = styled.div<{ $width: string }>`
  border: 1px solid ${colors.divider};
  border-radius: 0.5rem;
  padding: ${spacing.XS2};
  width: ${({ $width }) => $width};
  background: ${colors.neutralLight};

  & > img {
    width: 100%;
    height: 100%;
  }
`
